import React from 'react';
import Hero from '../sections/Hero';
import Services from '../sections/Services';
import Stats from '../sections/Stats';
import Products from '../sections/Products';
import Clients from '../sections/Clients';
import Portfolio from '../sections/Portfolio';
import TechStack from '../sections/TechStack';
import About from '../sections/About';
import WhyUs from '../sections/WhyUs';
import Process from '../sections/Process';
import CTA from '../sections/CTA';
import Contact from '../sections/Contact';

// Order follows the reference site (hero, services, achievements, products, clients, portfolio, toolbox),
// followed by the company sections from the project brief.
export default function Home() {
  return (
    <>
      <Hero />
      <Services />
      <Stats />
      <Products />
      <Clients />
      <Portfolio />
      <TechStack />
      <About />
      <WhyUs />
      <Process />
      <CTA title="Have a Project, an Idea, or a Team to Build?" highlight="Project" text="Let's talk. Discovery calls are free and usually surface things you didn't expect." />
      <Contact />
    </>
  );
}
